import { render, staticRenderFns } from "./NumberTemplate.vue?vue&type=template&id=3035aa70&scoped=true"
import script from "./NumberTemplate.vue?vue&type=script&lang=js"
export * from "./NumberTemplate.vue?vue&type=script&lang=js"
import style0 from "./NumberTemplate.vue?vue&type=style&index=0&id=3035aa70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3035aa70",
  null
  
)

export default component.exports